module.exports = __webpack_public_path__ + "img/Link_Line_16px_Icon-red.ae24165a.svg";